//
// locales/glitch/io.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/io';
import localeData from 'react-intl/locale-data/io.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
